import React from 'react';

import styles from './OptionCard.module.scss';

type Props = {
  label: string;
  emoji?: string;
  selected?: boolean;
  onClick?: () => void;
  /** 'single' → radio, 'multi' → checkbox */
  mode?: 'single' | 'multi';
};

export const OptionCard: React.FC<Props> = ({ label, emoji, selected, onClick, mode = 'single' }) => (
  <button
    type="button"
    className={`${styles.card} ${selected ? styles.selected : ''}`}
    onClick={onClick}
  >
    {emoji && <span className={styles.emoji}>{emoji}</span>}
    <span className={styles.label}>{label}</span>
    <span className={`${styles.control} ${mode === 'single' ? styles.radio : styles.checkbox}`}>
      {mode === 'single' ? <span className={styles.dot} /> : <span className={styles.tick} />}
    </span>
  </button>
);

export default OptionCard;
